import {Component, ChangeDetectionStrategy} from "@angular/core";
import {FormBuilder, Validators} from "@angular/forms";
import { HttpClient } from "@angular/common/http";
import {API_BASE_URL, LOGO_URL} from "../../utility/constants/api.constants";
import {Router} from "@angular/router";
import {finalize} from "rxjs";

@Component({
    selector: 'knust-password-reset',
    templateUrl: './password-reset.component.html',
    styleUrls: ['./password-reset.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class PasswordResetComponent {
  logoPath = LOGO_URL;

  currentStep = 0;
  currentButtonText = 'Verifizierungscode anfordern';
  currentButtonIcon = 'mail_outline'

  hidePassword = true;
  loading = false;
  requestFailed = false;

  pwResetForm = this.fb.group({
    username: ['', Validators.required],
    verificationCode: [''],
    newPassword: [''],
  });

  constructor(private fb: FormBuilder,
              private router: Router,
              private http: HttpClient) {
    this.pwResetForm.get('verificationCode')?.disable();
    this.pwResetForm.get('newPassword')?.disable();
  }

  nextStep() {
    if (this.loading) {
      return;
    }

    switch (this.currentStep) {
      case 0: {
        this.sendRequest(() => {
          this.currentStep++;

          this.pwResetForm.get('verificationCode')?.addValidators(Validators.required);
          this.pwResetForm.get('newPassword')?.addValidators(Validators.required);

          this.pwResetForm.get('verificationCode')?.enable();
          this.pwResetForm.get('newPassword')?.enable();

          this.currentButtonText = 'Neues Passwort setzen';
          this.currentButtonIcon = 'send';
        });
        break;
      }

      case 1: {
        this.sendRequest(() => {
          this.router.navigate(['/login']);
        });
        break;
      }
    }
  }

  switchPasswordVisibility(event: Event) {
    this.hidePassword = !this.hidePassword;

    event.stopPropagation();
  }

  // Der HttpErrorInterceptor beendet fehlgeschlagene Anfragen ohne Antwort (EMPTY). Ohne Antwort gilt die Anfrage
  // daher als fehlgeschlagen, damit der Ladezustand zurückgesetzt und ein Hinweis angezeigt wird.
  private sendRequest(onSuccess: () => void) {
    let succeeded = false;

    this.loading = true;
    this.requestFailed = false;

    this.http.post(API_BASE_URL + '/auth/reset', {...this.pwResetForm.value})
      .pipe(
        finalize(() => {
          this.loading = false;
          this.requestFailed = !succeeded;
        })
      )
      .subscribe({
        next: () => {
          succeeded = true;
          onSuccess();
        },
        error: () => undefined,
      });
  }
}
